import React from "react";
import { ListGroup, ListGroupItem } from 'reactstrap'
import { ManagePermission } from "./actionButtons/ManagePermission";
import { FormattedMessage } from 'react-intl';

function ListPermissions(props) {
  const {
    permissions,
    addPermissionToGroup,
    removePermissionFromGroup,
    displayPermissionsGroup,
    permissionType
  } = props;

  const noItems = () => {
    return (
      <ListGroupItem>
        <FormattedMessage id="messages.no_data"/>
      </ListGroupItem>
    );
  }

  const renderItems = (items) => {
    if (! Array.isArray( items ) || items.length === 0) {
      return noItems();
    }

    let itemsFiltered = [];
    items.forEach( (item, index) => {
      if (item.name.includes( permissionType )) {
        itemsFiltered[index] = item;
      }
    } );

    if (itemsFiltered.length === 0) {
      return noItems();
    }

    return itemsFiltered.map( renderItem );
  }

  const renderItem = (item, index) => {
    return (
      <ListGroupItem key={index} className="permission-item">
        <span className="permission-name">{`${item.translatedName}`}</span>
        <ManagePermission
          item={item}
          addPermissionToGroup={addPermissionToGroup}
          removePermissionFromGroup={removePermissionFromGroup}
          displayPermissionsGroup={displayPermissionsGroup}
          permissionType={permissionType}
          showIcon={true}
          index={index}
        />
      </ListGroupItem>
    );
  }

  return (
    <ListGroup className="permissions-list">
      {renderItems( permissions )}
    </ListGroup>
  );
}

export { ListPermissions }
